import { FBC_COOKIE, FBCLID_PARAM } from "@/platform/api/constants"
import { setCookie } from "@/platform/browser/cookies"

const FBC_MAX_AGE_SECONDS = 60 * 60 * 24 * 90

function buildFbcFromFbclid(fbclid: string, timestamp: number = Date.now()): string {
  return `fb.1.${timestamp}.${fbclid}`
}

export function captureFbclidToFbcCookie(): void {
  if (typeof window === "undefined") return

  const fbclid = new URLSearchParams(window.location.search).get(FBCLID_PARAM)
  if (!fbclid) return

  setCookie(FBC_COOKIE, buildFbcFromFbclid(fbclid), { maxAgeSeconds: FBC_MAX_AGE_SECONDS, sameSite: "Lax" })
}
